"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCadSystemNameSimplifyRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class OrCadSystemNameSimplifyRule {
    constructor(systemNameRule) {
        this.systemNameRule = systemNameRule;
        this.type = NetNamingRules_1.NetNamingRuleType.Finalize;
    }
    apply(_groups, _hierarchy) {
        this.systemNameRule.simplifyNonConflicting();
    }
}
exports.OrCadSystemNameSimplifyRule = OrCadSystemNameSimplifyRule;
//# sourceMappingURL=OrCadSystemNameSimplifyRule.js.map